import { ToastOptions } from 'react-toastify';

export const ORDER_CONFIRMATION_PAGE_TYPE_TEXT = 'text';
export const ORDER_CONFIRMATION_PAGE_TYPE_URL = 'url';

export const API_REQUEST_STATUS_NOT_SENT = 'not-sent';
export const API_REQUEST_STATUS_PENDING = 'pending';
export const API_REQUEST_STATUS_SUCCESS = 'success';
export const API_REQUEST_STATUS_FAIL = 'fail';

// better approach: include the above values in an object
// we also can include within components these 'helpers':
// const isLoading = status === API_REQUEST_STATUS_PENDING;
// const isSuccess = status === API_REQUEST_STATUS_SUCCESS;
// const isFail = status === API_REQUEST_STATUS_FAIL;

export const toastOptions: ToastOptions = {
  position: 'bottom-right',
  autoClose: 6000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
};

export const EVENT_TYPE_FREE = 'free';
export const EVENT_TYPE_WITH_SEATING_CHART = 'with-seating-chart';
export const EVENT_TYPE_WITH_CALENDAR = 'with-calendar';
export const EVENT_TYPE_PAID = 'paid';
